export default __webpack_public_path__ + "static/media/ecosystem_log3.1078f717.png";